export enum LocaleEnum {
  Arabic = 'ar-AE',
  ArabicSaudiArabia = 'ar-SA',
  Arabic_Area = 'ar',
  Assamese = 'as',
  Bengali = 'bn',
  Bodo = 'brx',
  Chinese = 'zh-CN',
  Dogri = 'doi',
  Dutch = 'nl-NL',
  English = 'en-US', // kept above en-GB to make it default for en
  EnglishUK = 'en-GB',
  EnglishIndia = 'en-IN',
  Gujarati = 'gu',
  Persian = 'fa',
  French = 'fr-FR',
  German = 'de-DE',
  Greek = 'el',
  Hebrew = 'he',
  Hindi = 'hi',
  Hungarian = 'hu',
  Italian = 'it-IT',
  Japanese = 'ja',
  Javanese = 'jv',
  Kannada = 'kn',
  Kashmiri = 'ks',
  Konkani = 'kok',
  Korean = 'ko',
  Maithili = 'mai',
  Malayalam = 'ml',
  Manipuri = 'mni',
  Marathi = 'mr',
  Nepali = 'ne',
  Odia = 'or',
  Punjabi = 'pa-IN',
  Polish = 'pl',
  Portuguese = 'pt',
  Romanian = 'ro',
  Russian = 'ru',
  Sanskrit = 'sa',
  Santhali = 'sat',
  Sindhi = 'sd',
  Spanish = 'es-ES',
  Tamil = 'ta',
  Telugu = 'te-IN',
  Turkish = 'tr',
  Ukrainian = 'uk',
  Urdu = 'ur',
  Vietnamese = 'vi',
}

export const RTL_LANGUAGES = new Set([
  LocaleEnum.Arabic,
  LocaleEnum.ArabicSaudiArabia,
  LocaleEnum.Arabic_Area,
  LocaleEnum.Hebrew,
  LocaleEnum.Kashmiri,
  LocaleEnum.Persian,
  LocaleEnum.Sindhi,
  LocaleEnum.Urdu,
]);

export const LOCALE_CASE_INSENSITIVE_MAP = new Map(
  Object.values(LocaleEnum).map((locale) => [locale.toLowerCase(), locale]),
);

export const LANGUAGE_DEFAULT_LOCALE_MAP = new Map(
  Object.values(LocaleEnum).reduce<Map<string, LocaleEnum>>((accumulator, locale) => {
    const languageCode = locale.split('-')[0];

    if (!accumulator.has(languageCode)) {
      accumulator.set(languageCode, locale);
    }

    return accumulator;
  }, new Map()),
);
